import React from "react";
import { useCallback } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router";
import { createMajorFormValidator } from "../../validators";
import { Field, Form } from "react-final-form";
import Paper from "@material-ui/core/Paper";
import { Theme } from "@material-ui/core/styles";
import Button from "../../../../components/Button";
import Container from "@material-ui/core/Container";
import Loading from "../../../../components/Loading";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import BootstrapInput from "../../../../components/BootstrapInput";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Error from "../../../../components/Error";
import { AdapterLink } from "../../../../components/Adopter";
import { useSnackbar } from "notistack";
import { useQuery } from "react-query";
import { Routes } from "../../../../constants/routes";
import { mutateErrors } from "../../../../utils";
import { FORM_ERROR } from "final-form";
import useMajorQueries from "../../hooks/useMajorQueries";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    padding: 35,
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      padding: 15,
    },
  },
  formControl: {
    marginBottom: theme.spacing(3),
  },
  root: {
    maxWidth: 300,
    margin: "0 auto",
  },
}));

export default function EditPage() {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const params = useParams<{ id: string }>();
  const { fetchOne, fetchUpdate } = useMajorQueries();
  const { isLoading, isFetching, isError, error, data } = useQuery<any>(
    "major_" + params.id,
    () => {
      return fetchOne(params.id);
    },
  );

  const update = useCallback(
    async (data) => {
      try {
        await fetchUpdate(data);
        history.push(`/0/${Routes.MAJORS}`);
        enqueueSnackbar("Success", { variant: "success" });
      } catch (e) {
        const { errors, message } = mutateErrors(e);
        enqueueSnackbar(message, { variant: "error" });
        return { [FORM_ERROR]: message, ...errors };
      }
    },
    [fetchUpdate],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading || isFetching) return <Loading />;

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <Container maxWidth="md" className={classes.container}>
      <Breadcrumbs>
        <AdapterLink to="/0">Home</AdapterLink>
        <AdapterLink to="/0/major">Majors</AdapterLink>
        <Typography color="textPrimary">Edit Major</Typography>
      </Breadcrumbs>
      <Paper>
        <Form
          onSubmit={update}
          validate={createMajorFormValidator}
          initialValues={{
            id: data && data.data.id,
            name: data && data.data.name,
          }}
        >
          {({ submitting, submitError, handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              {submitError && (
                <Typography color="error" align="center">
                  {submitError}
                </Typography>
              )}
              {submitting && <Loading />}
              <Typography component="div" className={classes.root}>
                <Typography component="div" className={classes.formControl}>
                  <Field
                    fullWidth
                    type="text"
                    name="name"
                    label="Name"
                    placeholder="Name"
                    component={BootstrapInput}
                  />
                  <Field
                    fullWidth
                    type="hidden"
                    name="id"
                    component={BootstrapInput}
                  />
                </Typography>
                <Typography
                  align="center"
                  component="div"
                  className={classes.formControl}
                >
                  <Button
                    type="submit"
                    color="secondary"
                    variant="contained"
                    disabled={submitting}
                  >
                    Update
                  </Button>
                </Typography>
              </Typography>
            </form>
          )}
        </Form>
      </Paper>
    </Container>
  );
}
